import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import CancelButton from "../../common/CancelButton";


export default function DetailsPage() {
    const [shippingCharges, setShippingCharges] = useState(null);

    const [isLoading2, setIsLoading2] = useState(false);
  
    const calculateShipping = (item) => {
      setIsLoading2(true);
      console.log(item);
      setTimeout(() => {
        setShippingCharges(39);
        setIsLoading2(false);
      }, 2000);
    };
  
    const confirmOrder = (data) => {
      setIsLoading2(true);
  
      // console.log(data);
      setTimeout(() => {
        Swal.fire({
          title: "Order Confirmed!",
          html: `Your order has been successfully confirmed. <br/><h5>Order ID - #${12345}</h5>`,
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        }).then(() => {
            console.log("User clicked OK");
            document.getElementById("closeConfirmOrderModal").click();
          });
  
        setIsLoading2(false);
      }, 2000);
    };
  
    const order = {
      orderID: "1234567",
      date: "Sep 19, 2024",
      retailerName: "Ritvik Sharma",
      shippingAddress: `12/45, Green Valley Apartment, MG Road,
      Near City Mall, Andheri West,
      Mumbai - 400058, Maharashtra, India`,
      billingAddress:
        "aditya Sharma, Gira Imperium, Shasthri Nagar, Lotus Residency, Wakad Road, Hinjewadi Phase 2, Pune 411057",
      pincode: "443001",
      waybill: "250070100004",
      status: "Not Picked",
      shippingCharges: shippingCharges,
      subtotal: 21720,
      discount: 4920,
      mrpDiscount: 1078,
      total: 25200,
      tax: 8400,
      transactionID: "#1234t3r3",
      currency: "₹",
      items: [
        {
          name: "Ollypop - Boys Half Sleeve Set",
          size: "M",
          color: "N/A",
          quantity: 3,
          price: 549,
          delprice: 678,
          totalItemPrice: 1647,
          imageUrl: "/assets/images/kidskart/order/o11.png",
        },
        {
          name: "Kids Full Sleeve Pajama Set",
          size: "L",
          color: "Blue",
          quantity: 2,
          price: 799,
          delprice: 999,
          totalItemPrice: 1598,
          imageUrl: "/assets/images/kidskart/order/o12.png",
        },
        {
          name: "Winter Jacket for Kids",
          size: "S",
          color: "Red",
          quantity: 1,
          price: 1599,
          delprice: 1999,
          totalItemPrice: 1599,
          imageUrl: "/assets/images/kidskart/order/o13.png",
        },
      ],
    };
  
    const {
      register,
      handleSubmit: handleConfirmOrder,
      formState: { errors },
      setError,
      clearErrors,
      reset,
    } = useForm();
  
    const {
      register: register2,
      handleSubmit: handleSubmitFeeCalculation,
      formState: { errors: errors2 },
      setError: setError2,
      clearErrors: clearErrors2,
      reset: reset2,
    } = useForm();
  
  return (
    <div>
      {/* <!-- Shipping Fee Calculation Modal --> */}
      <div
        className="modal fade"
        id="shippingFeeModal"
        tabindex="-1"
        aria-labelledby="shippingFeeModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="shippingFeeModalTitle">
                Shipping Fee Calculation
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form
              id="feeCalculationForm"
              data-form-label="feeCalculation"
              onSubmit={handleSubmitFeeCalculation(calculateShipping)}
            >
              <div className="modal-body">
                <p className="fs-6 mb-4 fw-bold">
                  Please enter the details below for shipping fee calculation.
                </p>
                <div className="container">
                  {/* <!-- Weight Input --> */}
                  <div className="row mb-4">
                    <label className="col-sm-5 col-form-label p-0">
                      Weight (In gm) <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0">
                      <input
                        {...register2("weight", {
                          required: "Please Enter Weight",
                          pattern: {
                            value: /^\d*\.?\d*$/,
                            message: "Please Enter only Numbers",
                          },
                          validate: (value) =>
                            parseFloat(value) > 0 || "Weight must be > 0",
                        })}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                      {errors2.weight && (
                        <p className="error">{errors2.weight.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Shipping Charges Display --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Shipping Charges
                    </label>
                    <div className="col-sm-7 p-0">
                      {shippingCharges && (
                        <span
                          className="fw-bold fs-5"
                          style={{ color: "green" }}
                        >
                          {order.currency}
                          {shippingCharges}/-
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {!isLoading2 ? (
                  <button type="submit" className="btn btn-primary col-12">
                    CALCULATE
                  </button>
                ) : (
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary col-12"
                      disabled
                    >
                      CALCULATE
                    </button>

                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Shipping Fee Calculation Modal --> */}

      {/* <!-- Order Confirmation Modal --> */}
      <div
        className="modal fade"
        id="orderConfirmationModal"
        tabIndex="-1"
        aria-labelledby="orderConfirmationModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="orderConfirmationModalTitle">
                Order Confirmation
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeConfirmOrderModal"
              ></button>
            </div>
            <form
              id="orderConfirmationForm"
              data-form-label="orderConfirmation"
              onSubmit={handleConfirmOrder(confirmOrder)}
            >
              <div className="modal-body">
                <p className="fs-6 mb-4 fw-bold">
                  Please enter the details below for order confirmation.
                </p>
                <div className="container">
                  {/* <!-- Box Width Input --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Box Width (In cm) <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0 mb-2">
                      <input
                        {...register("boxWidth", {
                          required: "Please Enter Box Width",
                          pattern: {
                            value: /^\d*\.?\d*$/,
                            message: "Please Enter only Numbers",
                          },
                          validate: (value) =>
                            parseFloat(value) > 0 || "Width must be > 0",
                        })}
                        className="form-control"
                        placeholder="Enter width"
                      />
                      {errors.boxWidth && (
                        <p className="error">{errors.boxWidth.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Box Height Input --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Box Height (In cm) <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0 mb-2">
                      <input
                        {...register("boxHeight", {
                          required: "Please Enter Box Height",
                          pattern: {
                            value: /^\d*\.?\d*$/,
                            message: "Please Enter only Numbers",
                          },
                          validate: (value) =>
                            parseFloat(value) > 0 || "Height must be > 0",
                        })}
                        className="form-control"
                        placeholder="Enter height"
                      />
                      {errors.boxHeight && (
                        <p className="error">{errors.boxHeight.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Box Weight Input --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Box Weight (In gm) <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0 mb-2">
                      <input
                        {...register("boxWeight", {
                          required: "Please Enter Box Weight",
                          pattern: {
                            value: /^\d*\.?\d*$/,
                            message: "Please Enter only Numbers",
                          },
                          validate: (value) =>
                            parseFloat(value) > 0 || "Weight must be > 0",
                        })}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                      {errors.boxWeight && (
                        <p className="error">{errors.boxWeight.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Pickup Date Input --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Pickup Date <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0 mb-2">
                      <input
                        {...register("pickupDate", {
                          required: "Please Select Pickup Date",
                        })}
                        type="date"
                        className="form-control"
                        min={
                          new Date(
                            new Date().toLocaleString("en-US", {
                              timeZone: "Asia/Kolkata",
                            })
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                        max={
                          new Date(
                            new Date(
                              Date.now() + 6 * 24 * 60 * 60 * 1000
                            ).toLocaleString("en-US", {
                              timeZone: "Asia/Kolkata",
                            })
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                      />
                      {errors.pickupDate && (
                        <p className="error">{errors.pickupDate.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Pickup Time Input --> */}
                  <div className="row mb-3">
                    <label className="col-sm-5 col-form-label p-0">
                      Pickup Time <strong className="asterisk">*</strong>
                    </label>
                    <div className="col-sm-7 p-0">
                      <input
                        {...register("pickupTime", {
                          required: "Please Select Pickup Time",
                        })}
                        type="time"
                        className="form-control"
                      />
                      {errors.pickupTime && (
                        <p className="error">{errors.pickupTime.message}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {!isLoading2 ? (
                  <button type="submit" className="btn btn-primary col-12">
                    CONFIRM ORDER
                  </button>
                ) : (
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary col-12"
                      disabled
                    >
                      CONFIRM ORDER
                    </button>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Order Confirmation Modal --> */}

      <div className="order-details-container row">
        <div className="col-sm-12 col-lg-12 col-xl-12 p-2 mb-2">
          {/* Shipping Details */}
          <div className="shipping-details">
            <div className="row">
              <div className="col-sm-6">
                <h6>Shipping Address: {order.retailerName}</h6>
                <p>{order.shippingAddress}</p>
              </div>
              <div className="col-sm-6">
                <h6>Billing Address: {order.retailerName}</h6>
                <p>{order.billingAddress}</p>
              </div>
            </div>

            <div className="row">
              <p className="col-sm-3">
                <strong>Pincode:</strong> {order.pincode}
              </p>
              <p className="col-sm-3">
                <strong>Waybill:</strong> {order.waybill}
              </p>
              <p className="col-sm-3">
                <strong>Transaction ID:</strong> {order.transactionID}
              </p>
              <p className="col-sm-3">
                <strong>Order Status:</strong>
                {"   "}
                <span className="order-status">{order.status}</span>
              </p>
            </div>
            <div className="row">
              <p className="col-sm-3">
                <strong>Shipping Charges:</strong> {order.currency}
                {shippingCharges
                  ? order.shippingCharges.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : 0.0}
              </p>
              <p className="col-sm-6">
                <button
                  className="download-button me-2"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#shippingFeeModal"
                  onClick={() => {
                    reset2();
                    setShippingCharges(null);
                  }}
                >
                  Calculate Shipping Fee
                </button>
              </p>

              <p className="col-sm-3">
                <button className="download-button me-2">
                  Download Invoice
                </button>
                <img
                  src="/assets/images/kidskart/icon/file.png"
                  className="download-file"
                />
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-7 col-lg-7 col-xl-7 p-2">
          {/* Order Summary */}
          <div className="order-summary">
            <div className="order-header">
              <h4>Products</h4>
            </div>
            <div
              className="order-items-scroll"
              style={{
                maxHeight: "303px",
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              {order.items.map((item, index) => (
                <div className="order-item" key={index}>
                  <img
                    src={item.imageUrl}
                    alt="Product"
                    className="product-image"
                  />
                  <div className="item-details">
                    <h5>{item.name}</h5>
                    <div className="row">
                      <p className="col-sm-3 mb-1">Size: {item.size}</p>
                      <p className="col-sm-4 mb-1">Set Qty: {item.quantity}</p>
                      <p className="col-sm-5 mb-1">
                        <del className="me-2">
                          {order.currency}
                          {item.delprice.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </del>
                        {order.currency}
                        {item?.price.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                    <p className="item-total">
                      Total Item Price: {order.currency}
                      {(item?.price * item.quantity).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-sm-5 col-lg-5 col-xl-5 p-2 mb-2">
          {/* Pricing Details */}
          <div className="pricing-summary">
            <p>
              Sub Total:{" "}
              <span>
                {order.currency}
                {order.subtotal.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>
            {/* Item Discount */}
            {/* {(order?.tax_price + order?.shipping_fee + order?.total_amount - order?.final_amount) ? <p>
              Discount:{" "}
              <span>
                -₹
                {(order?.tax_price + order?.shipping_fee + order?.total_amount - order?.final_amount) ? (order?.tax_price + order?.shipping_fee + order?.total_amount - order?.final_amount).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }): 0}
              </span>
            </p> : null} */}
            <p>
              Total Tax:{" "}
              <span>
                {order.currency}
                {order.tax.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>
            <p>
              Item Discount:{" "}
              <span>
                -{order.currency}
                {order.discount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>
            <p>
              Shipping Fee:{" "}
              <span>
                {order.shippingCharges === 0
                  ? "Free"
                  : `${order.currency}${
                      shippingCharges &&
                      order.shippingCharges.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }`}
              </span>
            </p>
            <hr />
            <p className="order-total">
              Total Amount:{" "}
              <span>
                {order.currency}
                {order.total.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </p>

            {/* Action Buttons */}
            <div className="action-buttons mt-5 text-center">
              <button
                className="confirm-button btn btn-success mr-2 mt-5"
                // onClick={handleConfirmOrder}
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#orderConfirmationModal"
                onClick={() => {
                  reset();
                }}
              >
                CONFIRM
              </button>
              <CancelButton
                orderId={12345}
                onCancel={(id) => {
                  // Your cancel order logic here, e.g., API call
                  console.log(`Order with ID ${id} has been cancelled.`);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
